module.exports = __webpack_public_path__ + "img/FI05337550.f3af157f.png";